import { jsx as _jsx } from "react/jsx-runtime";
import { legalNote } from './legalNoteText';
import './LegalNote.scss';
const LegalNote = () => {
    return _jsx("div", { className: "section legal-note-text", children: legalNote });
};
export default LegalNote;
